export default {
  pageNotFound: {
    height: '100vh'
  }
}
